module.exports = {
          srcSet: __webpack_public_path__ + "public/c31f0e866c04df047d3c4143b8869098-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/c31f0e866c04df047d3c4143b8869098-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/c31f0e866c04df047d3c4143b8869098-80.png",
          toString:function(){return __webpack_public_path__ + "public/c31f0e866c04df047d3c4143b8869098-80.png"},
          
          width: 80,
          height: 80
        }